import React from "react";

import { Badge, Collapse, Skeleton } from "antd";

const { Panel } = Collapse;

const NotasTurmaOrigem = ({ turma }) => {
    const disciplinas = turma?.disciplinas ?? [];

    const renderBadgeImportadas = avaliacoes => {
        const naoImportadas = avaliacoes.filter(a => !a.importada);

        return naoImportadas.length > 0 && <Badge count={naoImportadas.length} style={{ backgroundColor: "orange" }} />;
    };

    return (
        <div className="bloco">
            <div>
                <div>{turma?.escola}</div>
                <div style={{ fontSize: 20, marginBottom: 40 }}>{turma?.nome} (Origem)</div>
            </div>
            <div>
                {disciplinas?.length === 0 && (
                    <div className="skeleton-loading">
                        {Array.from({ length: 10 }).map((_, index) => (
                            <Skeleton key={index} paragraph={false} title={{ width: 300 }} active />
                        ))}
                    </div>
                )}
                {disciplinas?.length > 0 && (
                    <Collapse accordion defaultActiveKey={[]} className="collapse-diario-observacoes">
                        {disciplinas?.map((disciplina, index) => (
                            <Panel
                                header={
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
                                        <span style={{ width: "80%" }}>{disciplina.nome}</span>
                                        {renderBadgeImportadas(disciplina.avaliacoes)}
                                    </div>
                                }
                                key={index}
                            >
                                {disciplina.periodos?.map(periodo => (
                                    <div
                                        key={periodo.id}
                                        style={{ paddingBottom: 20, marginBottom: 20, borderBottom: "1px solid rgba(0, 0, 0, 0.04)" }}
                                    >
                                        <label style={{ fontSize: "16px" }}>{periodo.titulo}</label>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 20 }}>
                                            {disciplina.avaliacoes
                                                ?.filter(a => a.id_periodo === periodo.id)
                                                .map(avaliacao => (
                                                    <div
                                                        key={avaliacao.id}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            gap: 10
                                                        }}
                                                    >
                                                        <span>{avaliacao.nome}</span>
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                border: avaliacao.importada ? "1px solid #d0d2d3" : "2px solid orange",
                                                                borderRadius: "4px",
                                                                height: "30px",
                                                                width: "100px",
                                                                padding: "5px"
                                                            }}
                                                        >
                                                            {disciplina.tipoNotas
                                                                ? avaliacao.nota?.nota_numero
                                                                : avaliacao.nota?.nota_texto}
                                                        </span>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                ))}
                            </Panel>
                        ))}
                    </Collapse>
                )}
            </div>
        </div>
    );
};

export default NotasTurmaOrigem;
